


























import { Component, Prop, Vue, Emit, Ref, Watch } from 'vue-property-decorator';
import SaveImgVue from '@tencent/wphk-components-save-image/index.vue';
import { biBrow } from '@tencent/fit-bi-sdk';
import { ScreenDialog } from '@tencent/wphk-ui';

@Component({
  components: {
    SaveImgVue,
    ScreenDialog,
  },
})
export default class CIndex extends Vue {
  @Ref('refGuideDownloadImg') refGuideDownloadImg;
  @Ref('refSaveImg') refSaveImg;

  @Prop() isShow!: boolean;

  /** 在图片生成ok后，再展示tip */
  public isShowTip = false;

  @Emit('close')
  public handleClose() {}
  /** html2canvas生成图片完成 */
  public handleGenDone() {
    this.isShowTip = true;
    biBrow('share_guide_downloadimg.genimg_success|生成图片成功');
  }

  @Watch('isShow')
  public watchIsShow() {
    if (this.isShow) {
      this.refGuideDownloadImg.show();

      this.$nextTick(() => {
        setTimeout(() => {
          this.handleGenImg();
        }, 400);
      });
      biBrow('share_guide_downloadimg.comp_brow|组件曝光');
    } else {
      this.refGuideDownloadImg.hide();
    }
  }

  // 生成图片
  private handleGenImg() {
    console.log('handleGenImg');
    this.refSaveImg.toImage({});
  }
}
